export default {
  namespaced: true,

  state: {
    collapse: false
  },

  getters: {
    isCollapsed: state => state.collapse
  },

  mutations: {
    TOGGLE(state) {
      state.collapse = !state.collapse;
    }
  }
};
